import { getCurrentInstance } from 'vue';

type GtmTracker = {
  trackEvent: (payload: Record<string, unknown>) => void;
};

export function useGtm() {
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error('useGtm() must be called inside setup()');
  }

  const gtm = (instance.proxy as { $gtm?: GtmTracker }).$gtm;

  function trackGtmEvent(
    event: string,
    category: string,
    action: string,
    label: string,
    value = 5000,
    noninteraction = false,
  ): void {
    if (!gtm) {
      return;
    }
    gtm.trackEvent({
      event,
      category,
      action,
      label,
      value,
      noninteraction,
    });
  }

  function trackGtmEcommerceEvent(event: string, price: number, isRoundTrip: boolean): void {
    if (!gtm) {
      return;
    }
    gtm.trackEvent({
      event,
      ecommerce: {
        item_name: 'Ride',
        value: price,
        currency: 'EUR',
        item_category: isRoundTrip ? 'Round trip' : 'One way trip',
        quantity: 1,
        price,
      },
    });
  }

  return {
    trackGtmEvent,
    trackGtmEcommerceEvent,
  };
}
